import { Component } from 'solid-js';

const Footer: Component = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer class="footer">
      <div class="container">
        <p class="footer-text">
          © {currentYear} Patrick Szymkowiak. Tous droits réservés.
        </p>
        <p class="footer-subtext">
          Développé avec SolidJS et Bun
        </p>
      </div>
    </footer>
  );
};

export default Footer;
